import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { List } from '../../models/list.model';
import { AuthenticationLog, RequestLog } from 'src/app/models/logs.model';
import { ConfigService } from 'src/app/core/services/config-service';

@Injectable()
export class LogsService {
  constructor(private http: HttpClient) {}

  configService = inject(ConfigService);

  requestLogs(params: {
    page: number;
    pageSize: number;
    sort: string;
    sortDirection: string;
    filter: string;
    userId: string;
  }): Observable<List<RequestLog>> {
    const url =
      this.configService.readConfig().baseUrlInfrastructure +
      `/logs/requests?PageSize=${params.pageSize}&PageNumber=${params.page}&Sort=${params.sort}&SortDirection=${params.sortDirection}&Filter=${params.filter}&UserId=${params.userId}`;
    return this.http.get<List<RequestLog>>(url);
  }

  authenticationLogs(params: {
    page: number;
    pageSize: number;
    sort: string;
    sortDirection: string;
    filter: string;
    userId: string;
  }): Observable<List<AuthenticationLog>> {
    const url =
      this.configService.readConfig().baseUrlInfrastructure +
      `/logs/authentication?PageSize=${params.pageSize}&PageNumber=${params.page}&Sort=${params.sort}&SortDirection=${params.sortDirection}&Filter=${params.filter}&UserId=${params.userId}`;
    return this.http.get<List<AuthenticationLog>>(url);
  }
}
